import type { AxiosError } from 'axios';
import { useCallback } from 'react';
import { useQuery } from 'react-query';

import * as insightApi from '@hotjar/webapp/domains/highlights/api';
import { queryClient } from '@hotjar/webapp/utils/react-query';

type ApiFunction = typeof insightApi.getUnseenHighlightsCount;
type ApiResponseType = Awaited<ReturnType<ApiFunction>>;

export function useUnseenHighlightsCount(siteId: string | null): {
  value: number | undefined;
  reset: () => void;
} {
  const { data: unseenHighlightsCountFromServer } = useQuery<ApiResponseType, AxiosError>(
    [insightApi.UNSEEN_HIGHLIGHTS_COUNT, siteId],
    () => insightApi.getUnseenHighlightsCount(siteId as string),
    {
      enabled: siteId !== null,
      staleTime: 5 * 60 * 1000, // 5 minutes.
      refetchInterval: 60_000, // 60 seconds.
    },
  );

  const resetCount = useCallback(() => {
    queryClient.setQueryData([insightApi.UNSEEN_HIGHLIGHTS_COUNT, siteId], 0);
  }, [siteId]);

  return { value: unseenHighlightsCountFromServer, reset: resetCount };
}
